import React from 'react';
import { RadioGroup } from 'react-form';
import { createReactFormValidator, required } from '../../utils/validation';
import SimpleRadio from '../Form/SimpleRadio';

const GenderField = ({ values, touched, getError, getWarning }) => {
    const genderTouched = touched.gender;
    const genderError = getError('gender');
    const genderWarning = getWarning('gender');

    return (
        <div className={`form-group row ${(genderTouched && genderError) && 'is-invalid'}`}>
            <div className="col-12">
                <RadioGroup
                    field="gender"
                    validate={createReactFormValidator(required)}
                >
                    <div className="row">
                        <div className="col-12">
                            <label className={'mb8 fw500'}>
                                Gender
                            </label>
                            <SimpleRadio
                                option={{ value: 'M', label: 'Male' }}
                                field={'gender'}
                                value={values.gender}
                            />
                            <SimpleRadio
                                option={{ value: 'F', label: 'Female' }}
                                field={'gender'}
                                value={values.gender}
                            />
                        </div>
                    </div>
                </RadioGroup>
                {genderTouched &&
                    ((genderError && <div className="invalid-feedback">{genderError}</div>) ||
                        (genderWarning && <div className="warning-feedback">{genderWarning}</div>))}
            </div>
        </div>
    );
};

export default GenderField;
